import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ThemeDropdown from "./ThemeDropdown";

export default function TopbarInner({
  title,
  eyebrow,
  onBack,
  onThemeToggle,
  showLogo = true,
  showThemeDropdown = true,
  titleColor,
  titleClassName = "",
  isDarkMode,
  toggleDarkMode,
  longestStreak = 0,
  isPremium = false,
  onLogoClick,
  onTitleClick,
}) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`topbar ${scrolled ? "scrolled" : ""}`}>
      <div className="topbar-left">
<button
  type="button"
  className="topbar-back subtle"
  onClick={onBack}
  aria-label="Retour"
>
  <ArrowLeft size={18} />
</button>

        {(eyebrow || title) && (
          <div className="topbar-titles">
            {eyebrow && <p className="topbar-eyebrow">{eyebrow}</p>}

            {title && (
              <h1
                className={`topbar-title ${titleClassName} ${
                  onTitleClick ? "topbar-title--clickable" : ""
                }`}
                style={titleColor ? { color: titleColor } : undefined}
                onClick={onTitleClick}
                role={onTitleClick ? "button" : undefined}
                tabIndex={onTitleClick ? 0 : undefined}
                onKeyDown={(event) => {
                  if (!onTitleClick) return;

                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onTitleClick();
                  }
                }}
              >
                {title}
              </h1>
            )}
          </div>
        )}
      </div>

      <div className="topbar-right">
        {showLogo &&
          (onLogoClick ? (
            <button
              type="button"
              className="topbar-logo-link"
              aria-label="Accueil"
              onClick={onLogoClick}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
            >
              <img src="/logo2.svg" alt="Logo" className="topbar-logo" />
            </button>
          ) : (
            <Link to="/" className="topbar-logo-link" aria-label="Accueil">
              <img src="/logo2.svg" alt="Logo" className="topbar-logo" />
            </Link>
          ))}
{showThemeDropdown && (
  <ThemeDropdown
    isDarkMode={isDarkMode}
    toggleDarkMode={toggleDarkMode}
    onThemeToggle={onThemeToggle}
    longestStreak={longestStreak}
    isPremium={isPremium}
  />
)}
      </div>
    </header>
  );
}
